import React, { useState, useRef, useEffect } from 'react';
import Header from './Header';
import { Box, Card, Typography, Button, TextField, Paper } from '@mui/material';
import { Send, Person, SmartToy } from '@mui/icons-material';
import './AllFiles.css';
import { endpoint } from '../../resource/Constant';
import axios from 'axios';
import { useNavigate } from 'react-router';

const ChatBot = () => {
  const [messages, setMessages] = useState([{ id: 1, sender: 'bot', text: 'Hello! How can I assist you today?' }]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);
  const email = localStorage.getItem('user_email');

  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchEmailCount = async () => {
      try {
        const response = await axios.get(`${endpoint}/api/aichatbot/email_count?user_email=${email}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
          // params: { user_email: email }
        });
        setCount(response.data.email_count);
        console.log('email.count  =', response.data.email_count);
      } catch (error) {
        console.error('Error fetching email count:', error);
      }
    };

    fetchEmailCount();
  }, [messages.length]);

  const handleSendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { id: Date.now(), sender: 'user', text: input };
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInput('');
    setLoading(true);

    if (count >= 10) {
      alert('You have exceeded the message limit. You will be logged out.');

      // Logout after 5 seconds
      setTimeout(() => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('chat_token');
        localStorage.removeItem('user_email');
        navigate('/chatbotbase');
      }, 500);

      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${endpoint}/api/aichatbot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`
        },
        body: JSON.stringify({ message: input, user_email: email })
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.detail || 'Failed to fetch response');

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: Date.now() + 2,
          sender: 'bot',
          text: result.message?.result || result.message
        }
      ]);
    } catch (err) {
      setMessages((prevMessages) => [...prevMessages, { id: Date.now() + 3, sender: 'bot', text: 'Sorry, something went wrong!' }]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  return (
    <>
      <Header />
      <Box className="all-files-container">
        <Typography variant="h5" sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold', color: '#1976d2' }}>
          AI Chat Assistant
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'gray' }}>
          Chat with our AI assistant and get instant responses.
        </Typography>

        <Paper
          sx={{
            height: { xs: '70vh', sm: '75vh', md: '70vh' },
            overflowY: 'auto',
            borderRadius: '12px',
            p: 2,
            backgroundColor: '#f4f6f8',
            boxShadow: 2
          }}
        >
          {messages.map((msg) => (
            <Box
              key={msg.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                mb: 1.5
              }}
            >
              {msg.sender === 'bot' && <SmartToy sx={{ mr: 1, color: '#1976d2' }} />}
              <Card
                sx={{
                  p: 1.5,
                  borderRadius: '10px',
                  maxWidth: '75%',
                  backgroundColor: msg.sender === 'user' ? '#1976d2' : '#e0e0e0',
                  color: msg.sender === 'user' ? '#fff' : '#000',
                  textAlign: msg.sender === 'user' ? 'right' : 'left',
                  boxShadow: 1
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: '200', color: 'black' }}>
                  {msg.text}
                </Typography>
              </Card>
              {msg.sender === 'user' && <Person sx={{ ml: 1, color: '#1976d2' }} />}
            </Box>
          ))}
          {loading && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, mt: 1 }}>
              <SmartToy sx={{ mr: 1, color: '#1976d2' }} />
              <Box sx={{ display: 'flex', gap: '5px' }}>
                <Box
                  sx={{
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#1976d2',
                    borderRadius: '50%',
                    animation: 'dot-flash 1.5s infinite ease-in-out'
                  }}
                />
                <Box
                  sx={{
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#1976d2',
                    borderRadius: '50%',
                    animation: 'dot-flash 1.5s infinite ease-in-out',
                    animationDelay: '0.2s'
                  }}
                />
                <Box
                  sx={{
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#1976d2',
                    borderRadius: '50%',
                    animation: 'dot-flash 1.5s infinite ease-in-out',
                    animationDelay: '0.4s'
                  }}
                />
              </Box>
            </Box>
          )}

          <div ref={chatEndRef} />
        </Paper>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSendMessage();
          }}
          style={{ display: 'flex', gap: '10px', marginTop: '10px' }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Type a message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyPress}
            sx={{
              // borderRadius: '20px',
              backgroundColor: 'white',
              boxShadow: 1
            }}
          />
          <Button type="submit" variant="contained" color="primary">
            <Send />
          </Button>
        </form>
      </Box>
    </>
  );
};

export default ChatBot;
